import { getMultiTitles } from '@/api/officialaccount'

// 保留原文的换行和空格，仅用 trim 判断是否有实际内容。
export async function getRandomTextOptions(text) {
  if (typeof text !== 'string' || !text.trim()) return []

  try {
    const res = await getMultiTitles({ text })
    const options = res && Array.isArray(res.data)
      ? res.data.filter(item => typeof item === 'string' && item.trim())
      : []
    if (options.length) return options
  } catch (error) {
    // 请求失败与空结果使用相同的原文兜底。
  }

  return Array(5).fill(text)
}
